import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AppRoutes } from './routes';
import { detectSystemLanguage } from './config/languages';

const App: React.FC = () => {
  const [currentLanguage, setCurrentLanguage] = useState<string>('auto');
  
  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferred-language');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    } else {
      const detectedLanguage = detectSystemLanguage();
      setCurrentLanguage(detectedLanguage);
      localStorage.setItem('preferred-language', detectedLanguage);
    }
  }, []);
  
  const handleLanguageChange = (lang: string) => {
    setCurrentLanguage(lang);
    localStorage.setItem('preferred-language', lang);
  };
  
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageChange}
        />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;